import React, { useContext } from "react";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import DeleteIcon from "../../svg/Delete";
import EditIcon from "../../svg/Edit";
import Constant from "../../Constants";

function LinkTable({ linkInserts, linkTotal, handleDeleteCartItem }) {
  const { t } = useContext(LanguageContext);
  const { categoryOptions, linkTypeItems } = Constant();

  return (
    <div id="linksSection" className="card mb-4">
      <div className="card-header d-flex justify-content-between pb-1 pt-4">
        <h4 className="card-title">{t("Link Insert(s)")}</h4>
        <p className="responsive-text-affiliation text-secondary" style={{ fontWeight: "700"}}>
          {t("Sub Total")}: ${linkTotal}
        </p>
      </div>
      <div className="table-responsive datatable-custom">
        <table className="table table-thead-bordered table-nowrap card-table responsive-table">
          <thead className="thead-light">
            <tr className="responsive-row">
              <th className="pe-md-2 fw-bold">#</th>
              <th className="ps-md-3 fw-bold">{t("Website")}</th>
              <th className="fw-bold">{t("Content")}</th>
              <th className="fw-bold">{t("Price")}</th>
              <th className="table-column-ps-0 fw-bold"></th>
            </tr>
          </thead>

          <tbody>
            {!!linkInserts?.length ? (
              linkInserts?.map((item, index) => (
                <tr
                  key={index}
                  className={`responsive-row ${
                    index === (linkInserts?.length || 0) - 1
                      ? ""
                      : "border-bottom"
                  }`}
                >
                  <td className="display-row align-middle justify-content-between pe-md-2 pb-sm-0 pb-md-6 fw-bold">
                    {index + 1}
                    <td className="kebab-menu-sm">
                      <div className="dropdowm float-end">
                        <button
                          type="button"
                          className="btn btn-ghost-secondary btn-icon btn-sm rounded-circle"
                          id="teamsDropdown2"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <i className="bi-three-dots-vertical"></i>
                        </button>

                        <div
                          className="dropdown-menu dropdown-menu-sm dropdown-menu-end"
                          aria-labelledby="teamsDropdown2"
                        >
                          <button className="dropdown-item d-flex align-items-center">
                            <i
                              style={{
                                marginLeft: "-2px",
                                marginRight: "8px",
                              }}
                            >
                              <EditIcon />
                            </i>
                            {t("Edit")}
                          </button>
                          <button className="dropdown-item js-add-to-favorites">
                            <i className="bi bi-file-earmark-plus dropdown-item-icon"></i>
                            {t("Add Content")}
                          </button>
                          <div className="dropdown-divider"></div>
                          <button
                            className="d-flex align-items-center dropdown-item text-danger"
                            onClick={() => handleDeleteCartItem(item?.uuid)}
                          >
                            <i
                              style={{
                                marginLeft: "-2px",
                                marginRight: "8px",
                              }}
                            >
                              <DeleteIcon />
                            </i>{" "}
                            {t("Delete")}
                          </button>
                        </div>
                      </div>
                    </td>
                  </td>
                  <td className="ps-md-3 pt-2 pt-md-4">
                    <div className="d-flex flex-column gap-2">
                      <div style={{ cursor: "pointer" }}>
                        <span className="h4 text-inherit">
                          {item?.insert?.offer?.domain?.domain}
                        </span>
                        <i className="bi bi-person-check ps-2 text-secondary fs-4"></i>
                      </div>
                      <div>
                      {
                        item?.insert?.offer?.domain?.categories?.length ? (
                          <span>
                            {item?.insert?.offer?.domain?.categories?.slice(0, 2)?.map((category, i) => (
                              <span
                                key={i}
                                className="badge bg-soft-secondary text-secondary me-1"
                              >
                                {categoryOptions[category]}
                              </span>
                            ))}
                            {
                              item?.insert?.offer?.domain?.categories?.length > 2 ? (
                                <span className="badge bg-soft-secondary text-secondary">+ {item?.insert?.offer?.domain?.categories?.length - 3} {t("...")}</span>
                              ) : ''
                            }
                          </span>
                        ) : (
                          <span className="badge bg-soft-secondary text-secondary">
                            {t("Any Category")}
                          </span>
                        )
                      }
                      </div>
                      <div className="">
                        <small className="text-secondary">
                          {item?.insert?.offer?.links} {t("links")} &nbsp;&bull;&nbsp;{" "}
                          {linkTypeItems[item?.insert?.offer?.type]}
                        </small>
                      </div>
                    </div>
                  </td>

                  <td className="d-flex flex-column gap-2 align-items-start">
                    <button
                      className="btn btn-outline-primary py-2 pe-2 text-start fs-6"
                      style={{ width: "200px" }}
                    >
                      <i className="bi-plus"></i> {t("Page Donor")}
                    </button>
                    <button
                      className="btn btn-outline-primary py-2 pe-2 text-start fs-6"
                      style={{ width: "200px" }}
                    >
                      <i className="bi-plus"></i> {t("Target Page & Anchor")}
                    </button>
                  </td>

                  <td className="price-sm justify-content-between">
                    <p> {t("Price")}</p>
                    <p className="fw-bold"> ${item?.insert?.offer?.price}</p>
                  </td>
                  <td className="price-tab">
                    <p className="fw-bold"> ${item?.insert?.offer?.price}</p>
                  </td>

                  <td className="table-column-ps-0 kebab-menu align-middle">
                    <div className="dropdowm">
                      <button
                        type="button"
                        className="btn btn-ghost-secondary btn-icon btn-sm rounded-circle"
                        id="teamsDropdown2"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i className="bi-three-dots-vertical fs-4"></i>
                      </button>

                      <div
                        className="dropdown-menu dropdown-menu-sm dropdown-menu-end"
                        aria-labelledby="teamsDropdown2"
                      >
                        <button className="dropdown-item d-flex align-items-center">
                          <i
                            style={{
                              marginLeft: "-2px",
                              marginRight: "8px",
                            }}
                          >
                            <EditIcon />
                          </i>
                          {t("Edit")}
                        </button>
                        <button className="dropdown-item js-add-to-favorites">
                          <i className="bi bi-file-earmark-plus dropdown-item-icon"></i>
                          {t("Add Content")}
                        </button>

                        <div className="dropdown-divider"></div>
                        <button
                          className="d-flex align-items-center dropdown-item text-danger"
                          onClick={() => handleDeleteCartItem(item?.uuid)}
                        >
                          <i
                            style={{
                              marginLeft: "-2px",
                              marginRight: "8px",
                            }}
                          >
                            <DeleteIcon />
                          </i>{" "}
                          {t("Delete")}
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="100%">
                  <div
                    className="text-center p-4"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      textAlign: "center",
                    }}
                  >
                    <img
                      className="mb-3"
                      src="https://static.articlesfactory.ai/app/svg/illustrations-light/oc-error.svg"
                      alt=""
                      style={{ width: "10rem" }}
                      data-hs-theme-appearance="dark"
                    />
                    <img
                      className="mb-3"
                      src="https://static.articlesfactory.ai/app/svg/illustrations/oc-error.svg"
                      alt=""
                      style={{ width: "10rem" }}
                      data-hs-theme-appearance="default"
                    />
                    <p className="mb-0">
                      {!linkInserts ? "Loading data" : "No data to show"}
                    </p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LinkTable;
